import type { SVGProps } from 'react'
const SvgCreditCardOff = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="credit-card-off_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#credit-card-off_svg__a)">
      <path d="m16.484 14.185-1.538-1.538v-3.66h-3.665l-3-3h6.665V4.554H6.853L5.146 2.848h9.8q.708 0 1.208.499.498.498.498 1.207v8.892q0 .202-.037.388a1.2 1.2 0 0 1-.131.35M6.827 8.987H3.054v4.46h8.237zm8.587 8.582-2.417-2.417H3.054q-.708 0-1.208-.498a1.65 1.65 0 0 1-.498-1.208V4.554q0-.673.46-1.16.461-.489 1.12-.533l1.693 1.693H3.054v1.433h.773L.465 2.625l1.114-1.114 14.948 14.945z" />
    </g>
  </svg>
)
export default SvgCreditCardOff
